module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-awesome/fontawesome-webfont.woff2?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome/fontawesome-webfont.woff2?v=4.7.0
// module chunks = 40